import React, { useState } from 'react';
import { Layout, Button, notification } from 'antd';
import {
  Formik, Form, FormikProps, FormikValues,
} from 'formik';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import LogoButton from '../../lib/logo-button';
import FormControl from '../../lib/form-control';

import { useActions } from '../../providers/actions-provider/actions.context';
import { SIGN_IN_PATH } from '../../routing/paths.constants';

const validationSchema = Yup.object().shape({
  email: Yup.string().required('Email is required').email(),
});

const ForgotUsername = (): JSX.Element => {
  const { userActions } = useActions();
  const [usernameSent, setUsernameSent] = useState(true);
  const { replace } = useHistory();
  return (
    <Layout className="auth-layout auth-layout__forgot-pass">
      <div className="form">
        <LogoButton />
        <Formik
          initialValues={{
            email: '',
          }}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values) => {
            setUsernameSent(true);
            const success = await userActions.forgotUsername(values.email);
            if (success) {
              notification.success({
                message: 'Success.',
                description:
                      'Username sent to your email',
              });
              replace(SIGN_IN_PATH);
            } else {
              setUsernameSent(false);
            }
          }}
        >
          {({ isSubmitting }: FormikProps<FormikValues>) => (
            <Form>
              <h2 className="auth-layout__form-title">Forgot username</h2>
              <p className="form__text">Enter your email associated with your account.</p>
              {
                !usernameSent
                  ? <p className="form__text" style={{ color: 'red' }}>Error while sending your username to your email, try again please.</p>
                  : null
              }
              <FormControl name="email" label="Email" type="text" inputClassName="form__input" wrapperClassName="form__label" />
              <Button className="auth-layout__form-submit" type="default" htmlType="submit" loading={isSubmitting}>
                Send username
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </Layout>
  );
};

ForgotUsername.displayName = 'ForgotUsername';

export default ForgotUsername;
